import { Events, on } from './events.js';

class ProductFormElement extends HTMLElement {
  connectedCallback() {
    try {
      // Keep hidden id + ATC state in sync when other pickers emit updates
      this._unsubscribe = on(Events.variant.update, (ev) => {
        try {
          if (!ev || !ev.detail || !ev.detail.variant) return;
          const form = this.querySelector('form');
          const idInput = form && form.querySelector('input[name="id"]');
          const atc = form && form.querySelector('[data-role="add-to-cart"], button[type="submit"]');
          if (idInput) idInput.value = String(ev.detail.variant.id);
          if (atc) atc.disabled = ev.detail.variant.available === false;
        } catch (_) {}
      });

      // Open dialog on successful add if configured on this form
      this._onAdded = on(Events.cart.added, (ev) => {
        try {
          const attr = this.getAttribute('data-open-dialog-on-add');
          if (!attr || attr.trim() === '') return;
          const id = String(attr).replace(/^#/, '');
          if (!id) return;
          try { if (window.store && window.store.dialog && typeof window.store.dialog.open === 'function') window.store.dialog.open(id); }
          catch (_) {}
        } catch (_) {}
      });
    } catch (_) {}
  }

  disconnectedCallback() {
    try { if (this._unsubscribe) this._unsubscribe(); } catch (_) {}
    try { if (this._onAdded) this._onAdded(); } catch (_) {}
  }
}

try {
  const TAG = 'product-form';
  if (!customElements.get(TAG)) customElements.define(TAG, ProductFormElement);
} catch (_) {}


